// extracted by mini-css-extract-plugin
export default {"loading_spinner":"LoadingSpinner_loading_spinner__tpjBk","spinner":"LoadingSpinner_spinner__VLs-b","spinner_container":"LoadingSpinner_spinner_container__2z-Vm"};